import PropTypes from 'prop-types';

export const taxEntryPropType = PropTypes.shape({
  taxEntryId: PropTypes.number.isRequired,
  postedFlag: PropTypes.string,
  periodName: PropTypes.string.isRequired,
  businessUnit: PropTypes.string,
  legalEntity: PropTypes.string,
  companyCode: PropTypes.string.isRequired,
  companyCodeDescription: PropTypes.string,
  taxYear: PropTypes.string,
  countryTaxTypeDesc: PropTypes.string,
  taxEntryActivityDescription: PropTypes.string,
  taxEntryActivityDesc: PropTypes.string,
  adjustmentDescription: PropTypes.string,
  currencyCode: PropTypes.string,
  netAmount: PropTypes.number.isRequired,
  grossAmount: PropTypes.number,
  reviewedFlag: PropTypes.string,
  fbosFlag: PropTypes.string,
  preparerName: PropTypes.string,
  createdOn: PropTypes.string,
  updatedOn: PropTypes.string,
  reviewerName: PropTypes.string,
  reviewedOn: PropTypes.string,
  reviewedSso: PropTypes.string,
  batchId: PropTypes.string,
  method: PropTypes.string,
  countryTaxType: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  taxEntryType: PropTypes.string.isRequired,
  createdSso: PropTypes.string,
  taxEntryActivity: PropTypes.string.isRequired,
  taxEntryComment: PropTypes.string,
  fromAdjustmentDesc: PropTypes.string,
  topsideFlag: PropTypes.string,
  glAccountOffsetDesc: PropTypes.string,
  bookType: PropTypes.string,
  bookTypeDescription: PropTypes.string,
  exceptionBasis: PropTypes.string,
});


export const attachmentPropType = PropTypes.shape({
  ATTACHMENT_ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  FILE_NAME: PropTypes.string.isRequired,
  FILE_TYPE: PropTypes.string.isRequired,
  FILE_IMAGE: PropTypes.string,
});
